import { Button } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Page } from '@flecto/ui/saas'

import { CardIdentities } from '../components/CardIdentities/CardIdentities'
import { FormProfileAccount } from '../components/FormProfileAccount/FormProfileAccount'
import { useFormProfileAccount } from '../hooks/useFormProfileAccount'

export function PageProfileAccount() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })

  const { isLoading } = useFormProfileAccount()

  return (
    <Page withContainer>
      <Page.Title>{t('page_account.title')}</Page.Title>
      <Page.Actions>
        <Button type='submit' form='form-profile-account' loading={isLoading}>
          {t('page_account.button_save')}
        </Button>
      </Page.Actions>
      <Page.Content>
        <FormProfileAccount id='form-profile-account' />
        <CardIdentities mt='lg' />
      </Page.Content>
    </Page>
  )
}
